export const entries = (obj: { [x: string]: any }) => {
  var ownProps = Object.keys(obj),
    i = ownProps.length,
    resArray = new Array(i) // preallocate the Array
  while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]]

  return resArray
}
